// extracted by mini-css-extract-plugin
export default {"notifier":"Notify_notifier__6gNQP","msg":"Notify_msg__wm6MW"};